module.exports = __webpack_public_path__ + "media/components/Cards/images/dashboard-image-cd7c9866da58433ab922a920c5213d6b.png";